import { CustomTable } from '@/components/Table';
import SuperCollapse from '@/components/sharedComponents/SuperCollapse';
import { updateMask } from '@/helpers/masks/cpf';
import { toCurrency } from '@/helpers/masks/toCurrency';
import { EventCourtesyProduct } from '@/model/EventCourtesyProduct';
import { VoucherAndCourtesy } from '@/model/VoucherAndCourtesy';
import React, { Fragment } from 'react';

interface VoucherCourtesyUIProps {
  voucherAndCourtesy?: VoucherAndCourtesy;
}

export const VoucherCourtesyUI: React.FC<VoucherCourtesyUIProps> = ({
  voucherAndCourtesy,
}): JSX.Element => {
  const countCourtesies = (): number => {
    let value = 0;
    if (
      voucherAndCourtesy &&
      voucherAndCourtesy.courtesies &&
      voucherAndCourtesy.courtesies.employees &&
      voucherAndCourtesy.courtesies.employees.length > 0
    ) {
      voucherAndCourtesy.courtesies.employees.forEach(data => {
        if (data.courtesys && data.courtesys.length > 0) {
          data.courtesys.forEach(courtesy => {
            value += Number(courtesy.amount);
          });
        }
      });
    }
    if (
      voucherAndCourtesy &&
      voucherAndCourtesy.courtesies &&
      voucherAndCourtesy.courtesies.contractors &&
      voucherAndCourtesy.courtesies.contractors.length > 0
    ) {
      voucherAndCourtesy.courtesies.contractors.forEach(data => {
        if (data.courtesys && data.courtesys.length > 0) {
          data.courtesys.forEach(courtesy => {
            value += Number(courtesy.amount);
          });
        }
      });
    }
    return value;
  };
  const countEmployeeCourtesies = (): number => {
    let value = 0;
    if (
      voucherAndCourtesy &&
      voucherAndCourtesy.courtesies &&
      voucherAndCourtesy.courtesies.employees &&
      voucherAndCourtesy.courtesies.employees.length > 0
    ) {
      voucherAndCourtesy.courtesies.employees.forEach(data => {
        if (data.courtesys && data.courtesys.length > 0) {
          data.courtesys.forEach(courtesy => {
            value += Number(courtesy.amount);
          });
        }
      });
    }
    return value;
  };
  const countProducerCourtesies = (): number => {
    let value = 0;
    if (
      voucherAndCourtesy &&
      voucherAndCourtesy.courtesies &&
      voucherAndCourtesy.courtesies.contractors &&
      voucherAndCourtesy.courtesies.contractors.length > 0
    ) {
      voucherAndCourtesy.courtesies.contractors.forEach(data => {
        if (data.courtesys && data.courtesys.length > 0) {
          data.courtesys.forEach(courtesy => {
            value += Number(courtesy.amount);
          });
        }
      });
    }
    return value;
  };
  const countCourtesiesPDV = (): number => {
    let value = 0;
    if (
      voucherAndCourtesy &&
      voucherAndCourtesy.courtesies &&
      voucherAndCourtesy.courtesies.pdvs &&
      voucherAndCourtesy.courtesies.pdvs.length > 0
    ) {
      voucherAndCourtesy.courtesies.pdvs.forEach(data => {
        value += data.tickets.length;
      });
    }
    return value;
  };
  const abc = (): Record<string, EventCourtesyProduct[]> => {
    if (
      voucherAndCourtesy &&
      voucherAndCourtesy.courtesyProducts &&
      voucherAndCourtesy.courtesyProducts.length > 0
    ) {
      const x = voucherAndCourtesy.courtesyProducts.reduce<Record<string, EventCourtesyProduct[]>>(
        (acc, item) => {
          const key = item.posId || item.serialNumber || 'sem-pos';

          if (!acc[key]) {
            acc[key] = [];
          }

          acc[key].push(item);

          return acc;
        },

        {},
      );
      return x;
    }
    return {};
  };

  return (
    <div className="justify-content-between mt-5 mb-5">
      <h5>Voucher e Courtesia</h5>
      <SuperCollapse
        width={'100%'}
        title={`Voucher gerados (${
          voucherAndCourtesy && voucherAndCourtesy.vouchers && voucherAndCourtesy.vouchers.length
            ? voucherAndCourtesy.vouchers.length
            : 0
        })`}
        content={
          <>
            <CustomTable
              numberRowsPerPage={0}
              progressPending={false}
              theme="secondary"
              columns={[
                {
                  name: 'Voucher',
                  selector: row => row.descript,
                  width: '30%',
                },
                {
                  name: 'Usuário',
                  selector: row => row.user,
                  width: '20%',
                },
                {
                  name: 'valor',
                  selector: row => row.value,
                  width: '20%',
                },
                {
                  name: 'Codigo',
                  selector: row => row.code,
                  width: '20%',
                },
              ]}
              data={
                voucherAndCourtesy &&
                voucherAndCourtesy.vouchers &&
                voucherAndCourtesy.vouchers.length > 0
                  ? voucherAndCourtesy.vouchers.map(voucher => ({
                      descript: voucher.description,
                      user: voucher.user,
                      value: toCurrency(voucher.value),
                      code: voucher.code,
                    }))
                  : []
              }
            />
          </>
        }
      />

      <SuperCollapse
        width={'100%'}
        title={`Cupons gerados (${
          voucherAndCourtesy &&
          voucherAndCourtesy.discountCoupons &&
          voucherAndCourtesy.discountCoupons.length
            ? voucherAndCourtesy.discountCoupons.length
            : 0
        })`}
        content={
          <>
            <CustomTable
              numberRowsPerPage={0}
              progressPending={false}
              theme="secondary"
              columns={[
                {
                  name: 'Descrição',
                  selector: row => row.name,
                  width: '30%',
                },
                {
                  name: 'Quantidade',
                  selector: row => row.amount,
                  width: '20%',
                },
                {
                  name: 'Valor',
                  selector: row => row.value,
                  width: '20%',
                },
                {
                  name: 'Código',
                  selector: row => row.code,
                  width: '20%',
                },
              ]}
              data={
                voucherAndCourtesy &&
                voucherAndCourtesy.discountCoupons &&
                voucherAndCourtesy.discountCoupons.length > 0
                  ? voucherAndCourtesy.discountCoupons.map(discountCoupon => ({
                      name: discountCoupon.name,
                      amount: discountCoupon.amount,
                      value: discountCoupon.discount,
                      code: discountCoupon.code,
                    }))
                  : []
              }
            />
          </>
        }
      />

      <h6>{`Courtesias geradas (${countCourtesies()})`}</h6>

      <SuperCollapse
        width={'100%'}
        title={`Técnicos (${countEmployeeCourtesies()})`}
        content={
          <>
            {voucherAndCourtesy &&
              voucherAndCourtesy.courtesies &&
              voucherAndCourtesy.courtesies.employees &&
              voucherAndCourtesy.courtesies.employees.length > 0 &&
              voucherAndCourtesy.courtesies.employees.map(employee => (
                <div key={employee.user.id}>
                  <label>{`${employee.user.name} - ${updateMask(employee.user.cpf)}`}</label>
                  <CustomTable
                    numberRowsPerPage={0}
                    progressPending={false}
                    theme="secondary"
                    columns={[
                      {
                        name: 'Descrição',
                        selector: row => row.descript,
                        width: '30%',
                      },
                      {
                        name: 'Setor',
                        selector: row => row.section,
                        width: '20%',
                      },
                      {
                        name: 'Ingresso',
                        selector: row => row.ticket,
                        width: '20%',
                      },
                      {
                        name: 'QTD',
                        selector: row => row.quantity,
                        width: '20%',
                      },
                    ]}
                    data={
                      employee.courtesys && employee.courtesys.length > 0
                        ? employee.courtesys.map(courtesy => ({
                            descript: courtesy.description,
                            section: courtesy.ticket.eventSection.name || '---',
                            ticket: courtesy.ticket.name || '---',
                            quantity: courtesy.amount || '---',
                          }))
                        : []
                    }
                  />
                </div>
              ))}
          </>
        }
      />

      <SuperCollapse
        width={'100%'}
        title={`Produtores (${countProducerCourtesies()})`}
        content={
          <>
            {voucherAndCourtesy &&
              voucherAndCourtesy.courtesies &&
              voucherAndCourtesy.courtesies.contractors &&
              voucherAndCourtesy.courtesies.contractors.length > 0 &&
              voucherAndCourtesy.courtesies.contractors.map(employee => (
                <div key={`contractor-${employee.user.id}`}>
                  <label>{`${employee.user.name} - ${updateMask(employee.user.cpf)}`}</label>
                  <CustomTable
                    numberRowsPerPage={0}
                    progressPending={false}
                    theme="secondary"
                    columns={[
                      {
                        name: 'Descrição',
                        selector: row => row.descript,
                        width: '30%',
                      },
                      {
                        name: 'Setor',
                        selector: row => row.section,
                        width: '20%',
                      },
                      {
                        name: 'Ingresso',
                        selector: row => row.ticket,
                        width: '20%',
                      },
                      {
                        name: 'QTD',
                        selector: row => row.quantity,
                        width: '20%',
                      },
                    ]}
                    data={
                      employee.courtesys && employee.courtesys.length > 0
                        ? employee.courtesys.map(courtesy => ({
                            descript: courtesy.description,
                            section: courtesy.ticket.eventSection.name || '---',
                            ticket: courtesy.ticket.name || '---',
                            quantity: courtesy.amount || '---',
                          }))
                        : []
                    }
                  />
                </div>
              ))}
          </>
        }
      />
      {voucherAndCourtesy &&
        voucherAndCourtesy.courtesies &&
        voucherAndCourtesy.courtesies.pdvs &&
        voucherAndCourtesy.courtesies.pdvs.length > 0 && (
          <Fragment>
            <h6>{`Courtesias geradas PDV(${countCourtesiesPDV()})`}</h6>

            {voucherAndCourtesy.courtesies.pdvs.map(pdv => (
              <SuperCollapse
                key={pdv.pdvId}
                width={'100%'}
                title={`${pdv.pdvName} (${pdv.tickets.length})`}
                content={
                  <CustomTable
                    numberRowsPerPage={0}
                    progressPending={false}
                    theme="secondary"
                    columns={[
                      {
                        name: 'POS',
                        selector: row => row.pos,
                        width: '20%',
                      },
                      {
                        name: 'Evento',
                        selector: row => row.event,
                        width: '20%',
                      },
                      {
                        name: 'Setor',
                        selector: row => row.section,
                        width: '20%',
                      },
                      {
                        name: 'Ingresso',
                        selector: row => row.ticket,
                        width: '20%',
                      },
                      {
                        name: 'Data',
                        selector: row => row.date,
                        width: '20%',
                      },
                    ]}
                    data={
                      pdv.tickets && pdv.tickets.length > 0
                        ? pdv.tickets.map(ticket => ({
                            pos: ticket.serialNumber,
                            event: ticket.eventName || '---',
                            section: ticket.sectionName || '---',
                            ticket: ticket.ticketName || '---',
                            date: ticket.courtesyDate || '---',
                          }))
                        : []
                    }
                  />
                }
              />
            ))}
          </Fragment>
        )}

      {voucherAndCourtesy &&
        voucherAndCourtesy.courtesyProducts &&
        voucherAndCourtesy.courtesyProducts.length > 0 && (
          <div>
            <h6 className="mt-4">Produtos em cortesia</h6>

            {Object.entries(abc).map(([posId, products], index) => {
              const firstProduct = products[0];

              return (
                <SuperCollapse
                  key={`${posId}-${index}`}
                  width={'100%'}
                  title={
                    <CustomTable
                      numberRowsPerPage={0}
                      progressPending={false}
                      theme="secondary"
                      columns={[
                        {
                          name: 'POS',
                          selector: row => row.pos,
                          width: '40%',
                        },
                        {
                          name: 'Quantidade',
                          selector: row => row.quantity,
                          width: '20%',
                        },
                      ]}
                      data={[
                        {
                          pos: firstProduct.serialNumber || 'Sem POS',
                          quantity: products.length,
                        },
                      ]}
                    />
                  }
                  content={
                    <CustomTable
                      numberRowsPerPage={0}
                      progressPending={false}
                      theme="secondary"
                      columns={[
                        {
                          name: 'POS',
                          selector: row => row.pos,
                          width: '15%',
                        },
                        {
                          name: 'Evento',
                          selector: row => row.event,
                          width: '25%',
                        },
                        {
                          name: 'Produto',
                          selector: row => row.product,
                          width: '25%',
                        },
                        {
                          name: 'QTD',
                          selector: row => row.quantity,
                          width: '10%',
                        },
                        {
                          name: 'PDV',

                          selector: row => row.pdv,

                          width: '15%',
                        },
                        {
                          name: 'Data',
                          selector: row => row.date,
                          width: '15%',
                        },
                      ]}
                      data={products.map(
                        (item: {
                          serialNumber: any;
                          eventName: any;
                          productName: any;
                          quantity: any;
                          pdvName: any;
                          courtesyDate: any;
                        }) => ({
                          pos: item.serialNumber || '---',
                          event: item.eventName || '---',
                          product: item.productName || '---',
                          quantity: item.quantity || '---',
                          pdv: item.pdvName || '---',
                          date: item.courtesyDate || '---',
                        }),
                      )}
                    />
                  }
                />
              );
            })}
          </div>
        )}
    </div>
  );
};
